<input type="text" pInputText [(ngModel)]="idsFerias" *ngIf="!exibirContinuar" />
<br />
<button pButton *ngIf="!exibirContinuar" type="button" label="Enviar para Folha" class="primary" (click)="enviarHomologacao()"></button>
<ng-container *ngFor="let item of itensParaEnvio">
    <span *ngIf="!item.sucesso" style="color: red; font-weight: bold">{{item.idFerias}}</span>
</ng-container>
<br />
<button pButton *ngIf="exibirContinuar" type="button" label="Continuar Envio" class="primary" (click)="continuarEnvio()"></button>
<br />
<p *ngFor="let resultado of resultado">
    <span *ngIf="resultado.sucesso" style="color: green; font-weight: bold">Sucesso: {{resultado.idFerias}}</span>
    <span *ngIf="!resultado.sucesso" style="color: red; font-weight: bold">Erro: {{resultado.idFerias}}</span>
</p>
